module.exports = __webpack_public_path__ + "static/img/video-play.98f88bbf.png";